import Vue from 'vue'
import lodash from 'lodash'

Vue.prototype._ = lodash
